<mat-card class="progress-snackbar-card" [ngClass]="'progress-snackbar-card--' + data.state">
    <mat-card-content class="d-flex align-items-center">
        <mat-progress-spinner *ngIf="data.state === 'loading'" mode="indeterminate" diameter="24">
        </mat-progress-spinner>
        <mat-icon *ngIf="data.state === 'success'" class="progress-snackbar-icon">check_circle</mat-icon>
        <mat-icon *ngIf="data.state === 'error'" class="progress-snackbar-icon">error</mat-icon>
        <div class="ms-3">
            <div *ngIf="data.title" class="progress-snackbar-title">{{data.title}}</div>
            <div *ngIf="data.message" class="progress-snackbar-message">{{data.message}}</div>
        </div>
    </mat-card-content>
</mat-card>
